import { useRoutes } from 'react-router-dom';

import Home from '~/pages/home/home';
import Privacy from '~/pages/policy/privacy';
import Terms from '~/pages/policy/terms';

export const useNav = () => {
  const routes = [
    { path: '/', element: <Home /> },
    { path: '/privacy-policy', element: <Privacy /> },
    { path: '/terms-of-use', element: <Terms /> },
  ];

  return { element: useRoutes(routes) };
};
